<template>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.0" :width="width" :height="height" viewBox="0 0 300.000000 300.000000" preserveAspectRatio="xMidYMid meet">
    <g transform="translate(0.000000,300.000000) scale(0.100000,-0.100000)" :fill="iconColor" stroke="none">
      <path d="M1462 2860 c-62 -38 -62 -39 -62 -572 l0 -483 -87 87 c-97 95 -117 108 -163 108 -72 0 -120 -51 -120 -127 l0 -48 223 -222 c221 -221 223 -223 265 -223 24 0 55 6 70 14 15 8 118 106 229 218 171 172 202 209 208 241 14 75 -43 147 -116 147 -56 0 -72 -10 -171 -108 l-88 -87 0 498 0 497 -33 36 c-42 46 -104 56 -155 24z"/>
      <path d="M963 981 c-74 -46 -83 -140 -19 -198 l36 -33 540 0 c593 0 583 -1 615 60 8 16 15 47 15 70 0 32 -7 48 -34 78 l-34 37 -544 3 c-525 2 -544 2 -575 -17z"/>
      <path d="M206 351 c-39 -26 -55 -57 -56 -109 0 -35 6 -49 34 -80 l34 -37 1279 -3 c703 -1 1292 0 1310 3 42 8 89 55 97 99 9 47 -15 101 -56 126 -33 20 -47 20 -1323 20 -1258 0 -1291 -1 -1319 -19z"/>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "IconExternalCredit",
    },
    width: {
      type: [Number, String],
      default: 20,
    },
    height: {
      type: [Number, String],
      default: 20,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
